import { QuizQuestion } from '@shared/types';
import SingleChoice from './SingleChoice';
import MultipleChoice from './MultipleChoice';
import TextInput from './TextInput';
import DateInput from './DateInput';
import PhoneInput from './PhoneInput';
import ScaleInput from './ScaleInput';
import CitySelect from './CitySelect';
import YesNoInput from './YesNoInput';

interface QuestionRendererProps {
  question: QuizQuestion;
  value: any;
  onChange: (value: any) => void;
  onFinished?: (value: any) => void; // Called when the input is "done" - each type defines when
}

export default function QuestionRenderer({ question, value, onChange, onFinished }: QuestionRendererProps) {
  switch (question.type) {
    case 'single':
      // Single choice: finished immediately on selection
      return <SingleChoice question={question} value={value} onChange={onChange} onAutoAdvance={onFinished} />;
    
    case 'multiple':
      // Multiple choice: finished when max selections reached
      return <MultipleChoice question={question} value={value} onChange={onChange} onFinished={onFinished} />;
    
    case 'text':
      // Text: finished on blur or enter
      return <TextInput question={question} value={value} onChange={onChange} onFinished={onFinished} />;
    
    case 'date':
      // Date: finished on blur
      return <DateInput question={question} value={value} onChange={onChange} onFinished={onFinished} minAge={18}/>;
    
    case 'phone':
      // Phone: finished on blur or enter
      return <PhoneInput question={question} value={value} onChange={onChange} onFinished={onFinished} />;
    
    case 'scale':
      // Scale: finished immediately on selection
      return <ScaleInput question={question} value={value} onChange={onChange} onAutoAdvance={onFinished} />;
    
    case 'city':
      // City: finished immediately on selection
      return <CitySelect question={question} value={value} onChange={onChange} onAutoAdvance={onFinished} />;
    
    case 'yesno':
      // Yes/No: finished immediately on selection
      return <YesNoInput question={question} value={value} onChange={onChange} onAutoAdvance={onFinished} />;
    
    default:
      return <div>Unknown question type: {question.type}</div>;
  }
}
